module.exports = __webpack_public_path__ + "static/img/3s-info-b4.8b4e854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-b4.jpg
// module id = inTp
// module chunks = 0